import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// Fetches the Order Request Queue (Received / Rejected / Assign Nurse tabs)
export const fetchPendingOrdersReducer = createAsyncThunk(
  "dashboard/fetchPendingOrders",
  async ({ tab = "Received", search = "", page = 1, limit = 5 } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParamsObj = { page: String(page), limit: String(limit) };
      if (tab) queryParamsObj.tab = tab;
      if (search) queryParamsObj.search = search;
      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseOrderQueue}?${queryParams}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || i18n.t("toast.failedToFetchOrderRequestQueue");
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching order request queue:", error);
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingTheOrderRequestQueue");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
